import React, { useCallback, useEffect, useMemo, useState } from "react";
import Axios from "axios";
import url from "../services/url";
import GetFormComponent from "../pages/Candidate/GetFormComponent";
import CandidateFiles from "./CandidateFiles";
import CandidateSingleInterview from "./CandidateSingleInterview";
import { DownloadOutlined } from "@ant-design/icons";
import $ from "jquery";
import { Else, If } from "react-condition";
import Loading from "./Loading";
import axios from "../services/axios";
import RSelect from "react-select";
import CandidateDocumentForms from "./CandidateDocumentForms";
import { useHistory } from "react-router-dom";
import isAdmin from "../services/isAdmin";
import slugify from "slugify";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import ReactLoading from "react-loading";
import { Button, DatePicker } from "antd";
import DatePickerReact from "react-datepicker";
import SelectReact from "react-select";
import moment from "moment";
import swal from "sweetalert";
import config from "../config";
import locations from "../utils/api/locations";
import { Skill_TRF_Id, Trf_Edit_Right } from "../umConfig";
import {
  changeDateTimeFormat,
  formatDate,
  formatDateDDMMYYYY,
} from "../utils/commonFunctions";
import BASE from "../config";
import {
  Badge,
  Card,
  Modal,
  Radio,
  Steps,
  Timeline,
  Tooltip,
  message,
  Typography,
  Tag,
  Image,
} from "antd";
import StarRating from "react-star-ratings";
import {
  CalendarFilled,
  InfoCircleFilled,
  UserOutlined,
  ShareAltOutlined,
  CheckOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
  useField,
  useFormikContext,
} from "formik";
import RDatePicker from "react-datepicker";
import { Collapse, Breadcrumb } from "antd";
import { Select } from "antd";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import RejectImage from "../images/reject.jpg";
// import RSelect from "react-select";
import CandidateForms from "./candidate/CandidateForms";
import useGetFile from "../hooks/useGetFile";
import useAuthUserToken from "../hooks/useAuthUserToken";
import useAxios from "../hooks/useAxios";
import ButtonHint from "./ButtonHint";
import * as Yup from "yup";
import Header from "./components/Header";
import { useLocation } from "react-router-dom";
import useRole from "../hooks/useRole";
import TRFIndicator from "./components/TRFIndicator";
import VoiceBotDetails from "./components/VoiceBotDetails";
import { socket, joinCandidateRoom, leaveCandidateRoom } from "../services/socket";
import LanguageConfidence from "./components/LanguageConfidence";
import { checkBulkPermissions } from "../utils/checkPermission";
import ExtraScore from "./components/ExtraScore";

const { Option } = Select;
const { Title, Text } = Typography;
const { Step } = Steps;

const INTERVIEWTYPE = {
  L1: "L1",
  L2: "L2",
  L3: "final",
  L4: "clientRound",
};

const DatePickerField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();

  const [field] = useField(props);
  return (
    <DatePickerReact
      {...field}
      {...props}
      selected={(field.value && new Date(field.value)) || null}
      onChange={(val) => {
        setFieldValue(field.name, val);
        if (field.name === "start") {
          const endDate = new Date(val.getTime() + 30 * 60000);
          setFieldValue("end", endDate);
        }
      }}
    />
  );
};

function CandidateSingleView({ id }) {
  const [candidate, setCandidate] = useState({
    _id: "",
    application: { _id: "" },
    createdAt: "",
    email: "",
    files: [],
    trf: {
      skills: "",
    },
    name: "",
    responses: [],
    updatedAt: "",
    skills: [],
  });
  const locationUrl = useLocation();
  const userRole = useRole();
  const searchParams = new URLSearchParams(locationUrl.search);
  const TAB = searchParams.get("tab" || "");
  const api = useAxios();
  const [formNames, setFormNames] = useState([]);
  const [processes, setProcesses] = useState([]);

  const [skills, setSkills] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  //usestate for history container
  const [interviewStatus, setInterviewStatus] = useState(false);

  const [statusResponse, setStatusResponse] = useState(false);
  const [feedbackDataL1, setFeedbackDataL1] = useState({});
  const [filledForms, setFilledForms] = useState([]);
  //Log status (log tree)
  const [logStatus, setLogStatus] = useState(null);
  const [feedbackRes, setFeedbackRes] = useState({});
  const [feedbackRes1, setFeedbackRes1] = useState({});
  const [updateTrf, setUpdateTrf] = useState(false);
  const [preferredLocation, setPreferredLocation] = useState([]);
  // Effects
  const [stepsVisible, setStepsVisible] = useState({});
  const [s3Files, setS3Files] = useState({
    resume: "",
    video: "",
    photo: "",
  });

  const { userToken } = useAuthUserToken();
  const { getImage } = useGetFile(userToken);
  const [documentType, setDocumentType] = useState("Local");
  const [formList, setFormList] = useState([]);
  const [formData, setFormData] = useState([]);
  const [isDocEmpty, setIsDocEmpty] = useState(false);
  const [isDocSent, setIsDocSent] = useState(false);
  const [location, setLocation] = useState("");
  const [locationData, setLocationData] = useState("");
  const [trfCollection, setTrfCollection] = useState([]);
  const [trfEditStatus, setTrfEditStatus] = useState(false);
  const [trfData, setTrfData] = useState({});
  const [trfErr, setTrfErr] = useState("");
  const [load, setLoad] = useState(false);
  const [copyLink, setCopyLink] = useState(false);
  const [dynamicInterviews, setDynamicInterviews] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const [arrangeInterview, setArrangeInterview] = useState(false);
  const [isDocReadyForSent, setIsDocReadyForSent] = useState(false);
  const [interviewId, setInterviewId] = useState(null);
  const [users, setUsers] = useState([]);
  const [tinData, setTinData] = useState(null);
  const [tinOptions, setTinOptions] = useState("");
  const [dynamicSteps, setDynamicSteps] = useState(0);
  const [isModalVisibleFeedback, setIsModalVisibleFeedback] = useState(false);
  const [callMaster, setCallMaster] = useState([]);
  const [callStatus, setCallStatus] = useState("");
  const [select1, setSelect1] = useState("");
  const [callStatusMaster, setCallStatusMaster] = useState([]);
  const [callStatusRes, setCallStatusRes] = useState("");
  const [select2, setSelect2] = useState("");
  const [isCallStatus, setIsCallStatus] = useState(false);
  const [extraScore, setExtraScore] = useState(false);
  const [showManualDisposition, setShowManualDisposition] = useState(false);

  const onClickAddManually = () => {
    setShowManualDisposition(true);
  };

  const now = new Date();
  const start = new Date(now);
  start.setMinutes(now.getMinutes() + 10);
  const end = new Date(start);
  end.setMinutes(start.getMinutes() + 30);

  // Permify Permissions State
  const [canViewCallDiscussion, setCanViewCallDiscussion] = useState(false);
  const [canSaveCallDiscussion, setCanSaveCallDiscussion] = useState(false);
  const [canEditTrf, setCanEditTrf] = useState(false);
  const [canEditCandidate, setCanEditCandidate] = useState(false);
  const [canResumeCv, setCanResumeCv] = useState(false);
  const [canArrangeInterview, setCanArrangeInterview] = useState(false);
  const [canSendNonAgentDocs, setCanSendNonAgentDocs] = useState(false);
  const [canViewHistory, setCanViewHistory] = useState(false);
  const [canEditAdditionalInfo, setCanEditAdditionalInfo] = useState(false);
  const [canProceedWithDocument, setCanProceedWithDocument] = useState(false);
  const [canTakeInterview, setCanTakeInterview] = useState(false);
  const [canMakeInterviewEditable, setCanMakeInterviewEditable] = useState(false);
  const [canSpecialTrfEdit, setCanSpecialTrfEdit] = useState(false);
  const [isAmeyoActive, setIsAmeyoActive] = useState(true);

  useEffect(() => {
    const fetchAmeyoStatus = async () => {
      try {
        const res = await api.get("/AmeyoServiceSettings", {
          tokenType: "user",
        });
        setIsAmeyoActive(res.data?.AmeyoServiceSettings?.isActive ?? true);
      } catch (err) {
        console.error("Ameyo status check failed in candidate single view:", err);
      }
    };
    fetchAmeyoStatus();
  }, []);

  useEffect(() => {
    const fetchPerms = async () => {
      const role = localStorage.getItem("user.role");
      if (!role) return;
      const checks = [
        { entityType: "candidate_profile_module", permission: "call_discussion_view" },
        { entityType: "candidate_profile_module", permission: "call_discussion_save" },
        { entityType: "candidate_profile_module", permission: "trf_details_edit" },
        { entityType: "candidate_profile_module", permission: "candidate_details_edit" },
        { entityType: "candidate_profile_module", permission: "additional_info_edit" },
        { entityType: "candidate_profile_module", permission: "resume_cv" },
        { entityType: "candidate_profile_module", permission: "arrange_interview" },
        { entityType: "candidate_profile_module", permission: "non_agent_docs_send" },
        { entityType: "candidate_profile_module", permission: "history_view" },
        { entityType: "candidate_profile_module", permission: "proceed_with_document" },
        { entityType: "candidate_profile_module", permission: "take_interview" },
        { entityType: "candidate_profile_module", permission: "make_interview_editable" },
        { entityType: "candidate_profile_module", permission: "special_trf_edit" },
      ];
      try {
        const results = await checkBulkPermissions(role, checks);
        const isAllowed = (perm) => results.find((r) => r.permission === perm)?.allowed || false;
        setCanViewCallDiscussion(isAllowed("call_discussion_view"));
        setCanSaveCallDiscussion(isAllowed("call_discussion_save"));
        setCanEditTrf(isAllowed("trf_details_edit"));
        setCanEditCandidate(isAllowed("candidate_details_edit"));
        setCanEditAdditionalInfo(isAllowed("additional_info_edit"));
        setCanResumeCv(isAllowed("resume_cv"));
        setCanArrangeInterview(isAllowed("arrange_interview"));
        setCanSendNonAgentDocs(isAllowed("non_agent_docs_send"));
        setCanViewHistory(isAllowed("history_view"));
        setCanProceedWithDocument(isAllowed("proceed_with_document"));
        setCanTakeInterview(isAllowed("take_interview"));
        setCanMakeInterviewEditable(isAllowed("make_interview_editable"));
        setCanSpecialTrfEdit(isAllowed("special_trf_edit"));
      } catch (err) {
        console.log("Permission check error:", err);
      }
    };
    fetchPerms();
  }, []);

  var initialValues = {
    rejectionReason: "",
    type: "",
    interviewer: "",
    designationInterviewsNamesMappingId: "",
    interviewBy: "",
    description: "",
    link:
      config.interviewConferenceLink +
      slugify(candidate.name).toLowerCase() +
      "-" +
      Math.floor(Math.random() * Math.floor(99999)),
    start: start,
    end: end,
  };

  const validationSchema = Yup.object({
    interviewer: Yup.string().required("Please choose a user."),
    description: Yup.string(),
    link: Yup.string(),
    start: Yup.date()
      .required("You must specify a start date.")
      .test(
        "is-future",
        "Start date and time must be greater than the current date and time",
        (value) => {
          return value && new Date(value) > new Date();
        },
      ),
    end: Yup.date()
      .required("You must specify an end date.")
      .test(
        "is-after-start",
        "End date and time must be greater than the start date and time",
        function (value) {
          const { start } = this.parent;
          return value && new Date(value) > new Date(start);
        },
      ),
  });

  const getLocations = async () => {
    try {
      const result = await api.get(`/location`, {
        tokenType: "user",
      });
      setPreferredLocation(result?.data?.locationMaster);
    } catch (err) {
      console.log(err);
    }
  };

  const getJoiningFormFilled = async () => {
    try {
      const forms = await api.get(
        `/companyDocuments/DocumentMaping/candidateId/${id}`,
        {
          tokenType: "user",
        },
      );
      setFilledForms([...forms.data]);
    } catch (err) {
      console.log(err);
    }
  };

  const getFormNames = async () => {
    try {
      const res = await api.get("/formtemplate", { tokenType: "user" });
      setFormNames(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getUsers = async () => {
    try {
      const res = await api.get("/interviews/users", { tokenType: "user" });
      setUsers(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getFormList = async () => {
    try {
      const { data } = await api.get(
        "candidateDocuments/formList/Document_Form",
        {
          tokenType: "user",
        },
      );
      setFormList(data.formList);
    } catch (err) {
      console.error(err);
    }
  };

  const getDoc = async () => {
    try {
      const result = await api.get(`/candidateDocuments/candidate/${id}`, {
        tokenType: "user",
      });
      const { candidateDocumentDetails } = result.data;
      let arr = [];
      for (let doc of formList) {
        const found = candidateDocumentDetails?.find(
          (obj) => obj?.formId?._id === doc?._id,
        );
        if (found) {
          doc.sentOn = found.createdAt;
          doc.isFormAlreadySent = true;
          doc.sentStatus = found.sentStatus;
          doc.isFilledStatus = found.isFilledStatus;
          doc.docId = found._id;
          doc.isFormAlreadySent = true;
        } else {
          doc.isFormAlreadySent = false;
          doc.sentStatus = false;
        }
        arr.push(doc);
      }
      setFormData(arr);
      setIsDocEmpty(candidateDocumentDetails?.length !== 0);
    } catch (err) {
      console.error(err);
    }
  };

  async function loadProcesses() {
    try {
      const { data } = await api.get("/processes", {
        tokenType: "user",
      });
      setProcesses(data.processes);
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    if (formList.length !== 0) {
      getDoc();
    }
  }, [formList]);

  useEffect(() => {
    Promise.all([
      getLocations(),
      loadProcesses(),
      getCallMasterData(),
      loadCandidate(),
      getJoiningFormFilled(),
      getFormNames(),
      getUsers(),
      getFormList(),
    ]);
  }, []);

  async function loadCandidate() {
    try {
      const { data } = await axios.get("candidates/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      setStepsVisible(data);
      setCandidate(data);
      setDocumentType(data.documentType);

      if (data.documentType === "S3" && BASE.storageType) {
        let pdf = "";
        let video = "";
        let photo = "";
        let profilePhoto = null;
        if (data?.files?.length !== 0) {
          for (let file of data?.files) {
            if (file.fieldname) {
              if (
                file.fieldname.toLowerCase().indexOf("profile photo:") !== -1
              ) {
                profilePhoto = file;
              }
            }
          }
        }

        if (profilePhoto) {
          photo = await getImage(profilePhoto?.path);
        }

        setS3Files({
          ...s3Files,
          photo: photo,
          video: video,
          resume: pdf,
        });
      }

      setIsLoading(false);
    } catch (e) {
      console.error(e);
    }
  }

  const trfStatus = () => {
    if (candidate?.isEmpTempIdCreated || candidate?.documentsVerifiedStatus) {
      if (canSpecialTrfEdit) {
        return candidate?.IsSelected || candidate?.documentsVerifiedStatus
          ? true
          : false;
      }
      if (
        (candidate?.L3_Status && candidate?.L3_Status !== "Selected") ||
        (candidate?.L1_Status && candidate?.L1_Status !== "Selected") ||
        (candidate?.L2_Status && candidate?.L2_Status !== "Selected") ||
        (candidate?.L4_Status && candidate?.L4_Status !== "Selected")
      ) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  };

  async function editBulkCandidate() {
    history.push(`/edit/${candidate?.form?._id}/${id}/?tab=${TAB}`);
  }

  // edit simple candidate profile
  async function updateCandidate(event) {
    if (
      (stepsVisible?.L3_Status === "Selected" &&
        stepsVisible?.trf?.trfType === "Sampark") ||
      (stepsVisible?.L4_Status === "Selected" &&
        stepsVisible?.trf?.trfType === "Sampark")
    ) {
      history.push(
        `/candidate-update/${candidate?.form?._id}/${id}/?tab=${TAB}#editable`,
      );
    } else {
      history.push(
        `/candidate-update/${candidate?.form?._id}/${id}/?tab=${TAB}`,
      );
    }
  }

  useEffect(() => {
    let candidateSkills = candidate?.trf?.skills
      .split(",")
      .filter((skill) => {
        return skill !== "";
      })
      .map((skill) => {
        let initialSkill = {
          name: skill.trim(),
          rating: 1,
          review: "",
        };
        candidate.skills.forEach((test) => {
          if (test.name === initialSkill.name) {
            initialSkill = test;
          }
        });
        return initialSkill;
      });
    setSkills(candidateSkills);
  }, [candidate]);

  // Events

  const showModalFeedback = (interviewId, interviewerId) => {
    setFeedbackRes(interviewId);
    setFeedbackRes1(interviewerId);
    setIsModalVisibleFeedback(true);
  };

  const handleCancelFeedback = () => {
    setIsModalVisibleFeedback(false);
  };

  const changeStatus = (e) => {
    setCallStatus(e.target.value);
    const textValue = callMaster?.find(
      (ele) => ele._id === e.target.value,
    )?.name;
    setSelect1(textValue || "");
    setSelect2("");
    if (textValue === "Connected") {
      setIsCallStatus(true);
    } else {
      setIsCallStatus(false);
    }
    setCallStatusRes("");
    setCallStatusMaster([]);
  };

  useEffect(() => {
    callStatus !== "" && getCallStatusMaster();
  }, [callStatus]);

  const changeStatusResponse = (e) => {
    setCallStatusRes(e.target.value);
    const textValue = callStatusMaster.find(
      (ele) => ele?._id === e.target.value,
    )?.callStatus;
    setSelect2(textValue || "");
  };

  const success = (e) => {
    if (e === "status") {
      message.success({ content: "Call Discussion Status updated!", key: "call_status_update" });
    } else if (e === "err") {
      message.error("Please select Call Status", 3);
    } else if (e === "trfErr") {
      message.error("Please select Location & TRF", 3);
    }
  };

  const [reminderTime, setReminderTime] = useState("");

  async function saveStatus(e) {
    const isNewDropdownSelection = Boolean(select1 || select2 || callStatus);

    const ameyoCallMaster = (candidate?.callMasterId || "").toLowerCase();
    const ameyoCallStatusMaster = (candidate?.callStatusMasterId || "").toLowerCase();

    const dbHasConnected = ameyoCallMaster.includes("connected");
    const dbHasFollowupCallback =
      ameyoCallStatusMaster.includes("followup_callback") ||
      ameyoCallStatusMaster.includes("followup-callback") ||
      ameyoCallStatusMaster.includes("followup callback") ||
      ameyoCallStatusMaster.includes("follow up-call back") ||
      ameyoCallStatusMaster.includes("follow up - call back") ||
      ameyoCallStatusMaster.includes("follow up");

    const isDbConnectedFollowup = dbHasConnected && dbHasFollowupCallback;

    if (isDbConnectedFollowup && !isNewDropdownSelection) {
      if (!reminderTime) {
        message.error("Reminder time is Required.");
        return;
      }
      await axios
        .put(
          `/candidate/ScheduleCalander/${candidate._id}`,
          {
            callSchedule: reminderTime,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          }
        )
        .then(async (res) => {
          setStatusResponse(!statusResponse);
          await loadCandidate();
          setCallStatus("");
          setCallStatusRes("");
          setSelect1("");
          setSelect2("");
          setReminderTime("");
          setShowManualDisposition(false);
          message.success(res.data?.message || "Schedule updated successfully");
        })
        .catch((err) => {
          const errorMsg =
            err.response?.data?.message || err.message || "Failed to schedule calendar";
          message.error(errorMsg);
        });
      return;
    }

    const isNonAgent = !isAmeyoActive || (candidate?.trf && candidate?.trf?.candidateType !== "Agent") || canViewCallDiscussion || showManualDisposition;

    if (isNonAgent) {
      const condition1 = callStatus !== "" && callStatusMaster.length === 0;
      const condition2 =
        callStatus !== "" &&
        callStatusMaster.length !== 0 &&
        callStatusRes !== "";

      const finalCondition = condition1 || condition2;
      if (finalCondition || reminderTime) {
        await axios
          .put(
            `/candidate/CallStatus/${candidate._id}`,
            {
              callMasterId: select1,
              callStatusMasterId: select2,
              userId: localStorage.getItem("user.id"),
              IsCallConnected: isCallStatus,
              callSchedule: reminderTime || "",
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user.token")}`,
              },
            }
          )
          .then(async (res) => {
            setStatusResponse(!statusResponse);
            await loadCandidate();
            setCallStatus("");
            setCallStatusRes("");
            setSelect1("");
            setSelect2("");
            setReminderTime("");
            setShowManualDisposition(false);
            success("status");
          })
          .catch((err) => { });
      } else {
        success("err");
      }
    } else {
      if (!reminderTime) {
        message.error("Reminder time is Required.");
        return;
      }
      await axios
        .put(
          `/candidate/CallStatus/${candidate._id}`,
          {
            callMasterId: select1 || candidate?.callMasterId || "",
            callStatusMasterId: select2 || candidate?.callStatusMasterId || "",
            userId: localStorage.getItem("user.id"),
            IsCallConnected: select1 ? isCallStatus : (candidate?.IsCallConnected ?? false),
            callSchedule: reminderTime || "",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          }
        )
        .then(async (res) => {
          setStatusResponse(!statusResponse);
          await loadCandidate();
          setReminderTime("");
          setShowManualDisposition(false);
          success("status");
        })
        .catch((err) => { });
    }
  }

  async function saveInterviewLog() {
    setLoad(true);
    axios
      .get(`/interviews/interviewLogs/${candidate._id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data;
        setLogStatus(data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoad(false);
      });
  }

  async function getCallMasterData() {
    await axios
      .get(`/callMaster?`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setCallMaster(res.data.callMaster);
      });
  }

  async function getCallStatusMaster() {
    setLoad(true);
    await axios
      .get(`/callStatusMaster/callMasterId/${callStatus}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setCallStatusMaster(res.data.callStatus);
        setLoad(false);
      });
  }

  //trf handler
  useEffect(() => {
    axios
      .get(
        `/trf?Department=&Location=${location}&trfStatus=${true}&isTRFAssignable=${true}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        },
      )
      .then((res) => {
        const data = res.data;
        setTrfCollection(data);
        // setLoading(false);
      });
  }, [location]);

  const [values, setValues] = useState("");
  const handleLocation = (e) => {
    setLocation(e.target.value);
    setValues("");
  };

  useEffect(() => {
    if (candidate?.form?.name === "skill development") {
      setLocation("Amritsar");
      setValues(Skill_TRF_Id);
      saveTrf();
    }
  }, [candidate]);

  const saveTrf = async (e) => {
    let flag = true;
    if (filledForms.length !== 0) {
      flag = await swal({
        title: "Warning",
        // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
        icon: "warning",
        content: {
          element: "div",
          attributes: {
            innerHTML: `<p style="text-align:center">The joining document will be reset after the TRF is changed.</p>`,
          },
        },
        buttons: {
          cancel: true,
          confirm: true,
        },
      });
    }
    if (!flag) return;

    if (values && values !== "" || candidate?.form?.name === "skill development") {
      setLoad(true);
      Axios.put(
        url("/candidate/candidateId/" + candidate._id),
        {
          trfId:
            candidate?.form?.name === "skill development"
              ? Skill_TRF_Id
              : values,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        },
      ).then(async (res) => {
        window.location.reload();
        // setTrfEditStatus(false);
        // setUpdateTrf(true);
        // await Promise.all([loadCandidate(), getInterviews(candidate?._id)]);
        setLoad(false);
      });
    } else {
      success("trfErr");
      setTrfErr("Please select Location & TRF");
    }
  };

  const trfEdit = async () => {
    await axios
      .get(`/trf/${candidate.trf?._id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setLocationData(res.data.result.location);
        axios
          .get(
            `/trf?Department=&Location=${res?.data?.result?.location
            }&trfStatus=${true}&isTRFAssignable=`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user.token")}`,
              },
            },
          )
          .then((res) => {
            const data = res.data;
            setTrfCollection(data);
            // setLoading(false);
          });
      });

    setTrfData(candidate?.trf);
    setTrfEditStatus(true);
    setUpdateTrf(false);
  };

  const onChange = (_, dateStr) => {
    setReminderTime(dateStr);
  };

  const disabledDate = (current) => {
    return current && current < moment().startOf("day");
  };

  const disabledTime = (current) => {
    if (!current || moment().isSame(current, "day")) {
      return {
        disabledHours: () => {
          return Array.from({ length: moment().hour() }, (_, i) => i);
        },
        disabledMinutes: () => {
          if (!current || moment().isSame(current, "hour")) {
            return Array.from({ length: moment().minute() }, (_, i) => i);
          }
          return [];
        },
        disabledSeconds: () => [],
      };
    }
    return {};
  };

  const bindForm = async (formId) => {
    try {
      setLoad(true);
      const res = await api.put(
        "/candidate/candidateProfile/form",
        {
          id: candidate._id,
          form: formId,
        },
        { tokenType: "user" },
      );

      await loadCandidate();

      message.success(res.data.message, 3);
    } catch (err) {
      if (err.response.data.code === 409) {
        const flag = await swal({
          title: "Warning",
          // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
          icon: "warning",
          content: {
            element: "div",
            attributes: {
              innerHTML: `<p style="text-align:center">${err.response.data.error}</p>`,
            },
          },
          buttons: {
            cancel: true,
            confirm: true,
          },
        });

        if (flag) {
          setLoad(true);
          Axios.put(
            url("/candidateLeads/inactiveCandidateLead/" + candidate._id),
            {},
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user.token")}`,
              },
            },
          )
            .then((res) => {
              console.log(res.data);
              history.push("/candidate_dashboard?tab=Application_Received");
            })
            .finally(() => {
              setLoad(false);
            });
        }
        return;
      }
      message.error(err.response.data.error, 3);
    } finally {
      setLoad(false);
    }
  };

  const getDynamicInterviews = async (designationId, departmentId) => {
    try {
      const dynamicInterviews = await api.get(
        `/competencyInterviewSetUp/competencyAllInterview/designationId/${designationId}/departmentId/${departmentId}/candidate/${candidate?._id}`,
        // `/competencyInterviewsetup/designationId/${trf?.designationId}`,
        {
          tokenType: "user",
        },
      );
      const dynamic = dynamicInterviews.data?.sort(
        (a, b) => a?.interviewNo - b?.interviewNo,
      );
      // let done = [];
      // let pending = [];

      // dynamic.forEach((item) => {
      // const Founded = interviews?.find(
      //   (ele) => item?._id === ele?.designationInterviewsNamesMappingId,
      // );
      // if (Founded) {
      // if (Founded.finished) {
      // done.push({
      //   ...item,
      //   interviewDetailsBind: Founded,
      // });
      // } else {
      //   pending.push({
      //     ...item,
      //     interviewDetailsBind: Founded,
      //   });
      // }
      // } else {
      // done.push({
      //   ...item,
      //   interviewDetailsBind: {},
      // });
      // }
      // });
      // done.sort((a, b) => b.interviewNo - a.interviewNo);
      // pending.sort((a, b) => a.interviewNo - b.interviewNo);
      // const final = [...pending, ...done];
      // setDynamicInterviews(done);
      setDynamicInterviews(dynamic);
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  const getProcessBasedVersantConf = async () => {
    try {
      const { data } = await api.get(
        `/processBasedVersant/departmentId/${candidate?.trf?.departmentId}/designationId/${candidate?.trf?.designationId}/processId/${candidate?.trf?.processId}/location/${candidate?.trf?.location}/candidateId/${candidate?._id}`,
        { tokenType: "user" },
      );

      const type = data?.versantBasedTRF?.versantType;
      setTinData(data);
      setTinOptions(type);
    } catch (err) {
      console.error(err);
    }
  };

  const getInterviews = async (_id) => {
    try {
      const interviews = await api.put(
        `/interviews`,
        {
          candidate: _id,
        },
        {
          tokenType: "user",
        },
      );
      setInterviews(interviews.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  const refreshInterviewDetails = async () => {
    const candidateId = candidate?._id || id;
    if (!candidateId) return;
    try {
      setLoad(true);
      const [candidateRes, interviewsRes] = await Promise.all([
        axios.get("candidates/" + candidateId, {
          headers: { Authorization: `Bearer ${localStorage.getItem("user.token")}` },
        }),
        api.put("/interviews", { candidate: candidateId }, { tokenType: "user" }),
      ]);
      if (candidateRes?.data) {
        setCandidate(candidateRes.data);
        setStepsVisible(candidateRes.data);
      }
      if (interviewsRes?.data) {
        setInterviews(interviewsRes.data);
      }
    } catch (err) {
      console.error("Error in refreshInterviewDetails:", err);
    } finally {
      setLoad(false);
    }
  };

  // Real-time WebSocket connection for automatic score and face verification updates
  useEffect(() => {
    const candidateId = id;
    if (!candidateId) return;

    joinCandidateRoom(candidateId);

    const handleCandidateScoreUpdate = (data) => {
      console.log("[WebSocket] Received real-time score / verification update:", data);
      const incomingId = data?.candidateId || data?._id;
      if (!incomingId || String(incomingId) === String(candidateId)) {
        message.info({ content: "Automatic Score / Face Verification update received!", key: "score_update" });
        refreshInterviewDetails();
      }
    };

    const handleCandidateJoined = (data) => {
      console.log("[WebSocket] Candidate joined interview room:", data);
      const incomingId = data?.candidateId || data?._id;
      if (!incomingId || String(incomingId) === String(candidateId)) {
        message.success({ content: "Candidate has joined the interview room!", key: "candidate_joined" });
        refreshInterviewDetails();
      }
    };

    const handleCallStatusUpdate = (data) => {
      console.log("[WebSocket] Received real-time call status update:", data);
      const incomingId = data?.candidateId || data?._id;
      if (!incomingId || String(incomingId) === String(candidateId)) {
        message.success({ content: "Call Discussion Status updated!", key: "call_status_update" });
        if (data?.reTry != null || data?.attempts != null) {
          const newRetry = data.reTry ?? data.attempts;
          setCandidate((prev) => ({
            ...prev,
            callMasterId: data?.callMasterId || prev?.callMasterId,
            callStatusMasterId: data?.callStatusMasterId || prev?.callStatusMasterId,
            ameyoData: {
              ...(prev?.ameyoData || {}),
              reTry: newRetry,
            },
            reTry: newRetry,
          }));
        }
        loadCandidate();
        refreshInterviewDetails();
      }
    };

    socket.on("candidate_score_updated", handleCandidateScoreUpdate);
    socket.on("candidate_joined_interview", handleCandidateJoined);
    socket.on("candidate_call_status_updated", handleCallStatusUpdate);

    return () => {
      leaveCandidateRoom(candidateId);
      socket.off("candidate_score_updated", handleCandidateScoreUpdate);
      socket.off("candidate_joined_interview", handleCandidateJoined);
      socket.off("candidate_call_status_updated", handleCallStatusUpdate);
    };
  }, [id]);

  const onSubmitInterview = async (values) => {
    setLoad(true);
    try {
      await api.post(
        `/interviews`,
        {
          rejectionReason: "",
          type:
            INTERVIEWTYPE[`L${interviewId?.interviewNo}`] ||
            `L${interviewId?.interviewNo}`,
          interviewer: values.interviewer,
          designationInterviewsNamesMappingId: interviewId?._id,
          interviewBy: localStorage.getItem("user.id"),
          description: values.description,
          link: values.link,
          start: values.start,
          end: values.end,
          candidate: candidate?._id,
          interviewNameId: interviewId?.interviewNamesId,
        },
        {
          tokenType: "user",
        },
      );
      await getInterviews(candidate?._id);
      setArrangeInterview(!arrangeInterview);
      message.success("Interview Arranged Successfully.", 3);
    } catch (err) {
      console.log(err);
      message.error(err.response.data.error, 3);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (candidate?._id) {
      getInterviews(candidate?._id);
    }
  }, [candidate?._id]);

  useEffect(() => {
    if (candidate?.trf?._id) {
      if (
        candidate?.trf?.designationId &&
        candidate?.trf?.departmentId &&
        candidate?.trf?.candidateType === "Non-Agent"
      ) {
        getDynamicInterviews(
          candidate?.trf?.designationId,
          candidate?.trf?.departmentId,
        );
      }
    }

    if (
      !candidate?.trf?.departmentId ||
      !candidate?.trf?.designationId ||
      !candidate?.trf?.processId
    )
      return;
    getProcessBasedVersantConf();
  }, [candidate?.trf]);

  useEffect(() => {
    let STEP = 0;
    if (dynamicInterviews.length !== 0) {
      Array.from([...dynamicInterviews])
        ?.sort((a, b) => a.interviewNo - b.interviewNo)
        ?.map((item) => {
          const Founded = interviews?.find(
            (ele) => item?._id === ele?.designationInterviewsNamesMappingId,
          );
          if (Founded && Founded?.finished) {
            STEP = item?.interviewNo;
          }
        });
    }

    if (candidate?.isDocumentSent === true) {
      STEP = dynamicInterviews?.length;
    }

    if (
      candidate?.isEmpTempIdCreated === true &&
      candidate?.documentsVerifiedStatus === true
    ) {
      STEP = STEP + 1;
    }

    setDynamicSteps(STEP);
  }, [interviews, dynamicInterviews, candidate]);

  const proceedWithDocument = async (e) => {
    if (
      candidate?.trf?.isTRFApproved !== true ||
      candidate?.trf?.Status === false
    ) {
      return swal({
        title: "",
        text: "You cannot proceed with the document as the TRF is either under process or rejected or inactive.",
        icon: "error",
        buttons: {
          cancel: false,
          confirm: true,
        },
      });
    }

    if (e.target.checked) {
      const flag = await swal({
        title: "Warning",
        text: `Do you want to proceed with documentation ${dynamicInterviews?.length !== interviews?.length
          ? "without completing all the interview rounds"
          : ""
          }.`,
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: true,
        },
      });

      if (flag) {
        setIsDocReadyForSent(true);
        try {
          setLoad(true);
          const result = await api.put(
            `/candidate/documentSentStatus/${candidate?._id}`,
            {},
            {
              tokenType: "user",
            },
          );
          message.success(result.data.message);
          window.location.reload();
        } catch (err) {
          console.log(err);
        } finally {
          setLoad(false);
        }
      }
    } else {
      setIsDocReadyForSent(false);
    }
  };

  const candidateFormId = candidate?.form?._id || candidate?.form || candidate?.formId;
  const LATERAL_FORM_IDS = ["633190214529e62d9edc2fff", "62e91154309f9f7d5806d044"];
  const isNonAgentForm = LATERAL_FORM_IDS.includes(String(candidateFormId));
  const isNonAgent_candidate = candidate?.trf?.candidateType === "Non-Agent" || isNonAgentForm;

  const IS_NON_AGENT =
    candidate?.trf?.candidateType === "Non-Agent" ? true : false;

  const currentFormStatusStr = [select1, select2]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  const isManualCallbackDisposition =
    currentFormStatusStr.includes("followup_callback") ||
    currentFormStatusStr.includes("followup-callback") ||
    currentFormStatusStr.includes("followup callback") ||
    currentFormStatusStr.includes("follow up-call back") ||
    currentFormStatusStr.includes("follow up - call back");

  const lastUserDisp = Array.isArray(candidate?.userDisposition)
    ? candidate.userDisposition[candidate.userDisposition.length - 1]
    : candidate?.userDisposition;
  const lastSysDisp = Array.isArray(candidate?.systemDisposition)
    ? candidate.systemDisposition[candidate.systemDisposition.length - 1]
    : candidate?.systemDisposition;

  const ameyoStatusStr = [
    candidate?.callMasterId,
    candidate?.callStatusMasterId,
    candidate?.ameyoData?.systemCallStatus,
    candidate?.systemCallStatus,
    lastUserDisp,
    lastSysDisp,
  ].filter(Boolean).join(" ").toLowerCase();

  const ameyoCallMaster = (candidate?.callMasterId || "").toLowerCase();
  const ameyoCallStatusMaster = (candidate?.callStatusMasterId || "").toLowerCase();

  const hasConnected = ameyoCallMaster.includes("connected");

  const hasFollowupCallback =
    ameyoCallStatusMaster.includes("followup_callback") ||
    ameyoCallStatusMaster.includes("followup-callback") ||
    ameyoCallStatusMaster.includes("followup callback") ||
    ameyoCallStatusMaster.includes("follow up-call back") ||
    ameyoCallStatusMaster.includes("follow up - call back");

  const isCallbackDisposition = hasConnected && hasFollowupCallback;

  const isDocumentReadyForSend = () => {
    if (dynamicInterviews.length !== 0 && IS_NON_AGENT) {
      if (interviews?.length !== dynamicInterviews?.length) {
        for (let item of interviews) {
          if (item?.status === "Rejected") {
            return false;
          }
        }
        return null;
      }

      if (interviews?.length === dynamicInterviews?.length) {
        const isSelected = interviews?.every(
          (item) => item?.status === "Selected",
        );
        if (isSelected) {
          return true;
        }

        return null;
      }
    } else {
      const versantInterview = interviews?.find(
        (item) => item?.type === "versant",
      );
      const isClientRoundExist = versantInterview?.clientRoundExist;
      const isVersantNotRequired = versantInterview?.isVersantNotRequired;

      if (isClientRoundExist || isVersantNotRequired) {
        if (interviews.length === 4) {
          const isSelected = interviews?.every(
            (item) => item?.status === "Selected",
          );
          if (isSelected) {
            return true;
          }
        } else {
          return null;
        }
      } else {
        if (interviews.length === 3) {
          const isSelected = interviews?.every(
            (item) => item?.status === "Selected",
          );
          if (isSelected) {
            return true;
          }
        } else {
          return null;
        }
      }
      return null;
    }
  };

  useEffect(() => {
    if (!candidate || interviews?.length === 0) return;

    if (isDocumentReadyForSend() || candidate?.isDocumentSent) {
      setIsDocSent(true);
    } else {
      setIsDocSent(false);
    }
  }, [
    interviews,
    dynamicInterviews,
    candidate?.isDocumentSent,
    candidate?.trf,
  ]);

  const sendLink = async (url) => {
    try {
      setLoad(true);
      await api.post(
        `/candidate/shareLink`,
        {
          candidateId: candidate?._id,
          url: url,
        },
        {
          tokenType: "user",
        },
      );
      message.success("Link Share with candidate on Whatsapp.");
    } catch (err) {
      console.error(err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoad(false);
    }
  };

  const findInterviewByType = useCallback(
    (type) => {
      const Founded = interviews?.find((ele) => ele?.type == type);
      if (Founded) {
        if (Founded.status === "Rejected") {
          return "error";
        } else if (Founded.finished) {
          return "finish";
        } else {
          return "wait";
        }
      } else {
        return "wait";
      }
    },
    [interviews],
  );

  const DISABLE_DOCUMENT_PROCESS =
    interviews?.length > 0 &&
    interviews?.every((item) => item?.finished === true) &&
    !candidate?.isDocumentSent;
  const IS_CALL_CONNECTED = candidate?.IsCallConnected;
  const isCallDiscussionAdded = !!(
    candidate?.callMasterId ||
    candidate?.callStatusMasterId
  );
  const showInterviewsComponent = true;
  const showAgentInterviews = true;
  const isCallDiscussionPending = false;



  const voiceBot = candidate?.voiceBotData?.latest || candidate?.voiceBotData;

  const LOCATION = voiceBot?.wfo_preferred_location
    ? voiceBot.wfo_preferred_location.charAt(0).toUpperCase() +
    voiceBot.wfo_preferred_location.slice(1)
    : candidate?.responses?.find((r) => r.label?.trim() === "Preferred Location")?.value ||
    candidate?.location ||
    "";

  const CURRENT_LOCATION =
    candidate?.current_location ||
    candidate?.responses?.find(
      (r) =>
        r.label?.trim()?.toLowerCase() === "current location" ||
        r.label?.trim()?.toLowerCase() === "current_location"
    )?.value ||
    candidate?.personalDetails?.["Current Location"] ||
    candidate?.personalDetails?.current_location ||
    "";

  const QUALIFICATION = voiceBot?.qualification_extraction
    ? voiceBot.qualification_extraction.charAt(0).toUpperCase() +
    voiceBot.qualification_extraction.slice(1)
    : candidate?.responses?.find((r) => r.label?.trim() === "Highest Qualification")?.value || "";

  let LANGUAGES = "";
  if (voiceBot?.English_and_Hindi) {
    if (voiceBot.English_and_Hindi.toLowerCase() === "yes") {
      LANGUAGES = "English, Hindi";
    } else {
      LANGUAGES = voiceBot.English_and_Hindi.charAt(0).toUpperCase() + voiceBot.English_and_Hindi.slice(1);
    }
  } else {
    const respVal = candidate?.responses?.find((r) => r.label?.trim() === "Languages Known")?.value;
    LANGUAGES = Array.isArray(respVal) ? respVal.join(", ") : (respVal || "");
    if (typeof LANGUAGES === "string" && LANGUAGES.toLowerCase() === "yes") {
      LANGUAGES = "English, Hindi";
    }
  }

  const breadcrumbs = [
    {
      label: locationUrl.state?.fromName || "Dashboard",
      url: locationUrl.state?.from || `/candidate_dashboard?tab=${TAB}`,
    },
    {
      label: candidate?.name,
      url: "",
    },
  ];

  return (
    <div>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <If test={isLoading === false}>
        <div className="candidate-details">
          <div className="container">
            <Header
              candidate={candidate}
              setLoad={setLoad}
              breadcrumbs={breadcrumbs}
              canResumeCv={canResumeCv}
            />
            <div className="row border px-2 py-3 mb-4 bg-white align-items-center">
              <div className="col-lg-2 flex flex-column gap-2 align-items-center p-0 my-lg-0 my-2">
                {s3Files?.photo !== "" ? (
                  // <img
                  //   // src="https://mdbcdn.b-cdn.net/img/new/avatars/2.webp"
                  //   src={url(imageLink)}
                  //   className="rounded-circle"
                  //   style={{ width: 100, height: 100 }}
                  //   alt="Avatar"
                  // />
                  <>
                    {/* {candidate?.candidatePhoto && ( */}
                    <img
                      style={{
                        width: 100,
                        height: 100,
                        border: "1px solid #fd7e14",
                      }}
                      className="img rounded-circle"
                      src={
                        documentType === "S3" && BASE.storageType
                          ? s3Files?.photo
                          : url() + candidate?.candidatePhoto[0]?.path
                      }
                      alt="avatar"
                    />
                    {/* )} */}
                  </>
                ) : (
                  <div
                    style={{
                      width: "100px",
                      height: "100px",
                      border: "1px solid black",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <UserOutlined style={{ fontSize: "4rem" }} />
                  </div>
                )}
              </div>
              {IS_NON_AGENT ? (
                <div className="col-lg-10 p-0 my-lg-0 my-2">
                  <Steps
                    current={dynamicSteps}
                    size="small"
                    labelPlacement="vertical"
                    percent={60}
                  >
                    {Array.from([...dynamicInterviews])
                      ?.sort((a, b) => a.interviewNo - b.interviewNo)
                      ?.map((item) => {
                        const Founded = interviews?.find(
                          (ele) =>
                            item?._id ===
                            ele?.designationInterviewsNamesMappingId,
                        );
                        return (
                          <Step
                            className="custum_step"
                            status={
                              Founded && Founded?.status === "Rejected"
                                ? "error"
                                : Founded && Founded?.finished === true
                                  ? "finish"
                                  : "wait"
                            }
                            title={item?.interviewDetails?.interviewNames}
                            subTitle={
                              Founded &&
                              Founded?.rejectionReason !== "" && (
                                <img
                                  src={RejectImage}
                                  style={{ width: 50, height: 50 }}
                                  alt=""
                                />
                              )
                            }
                          />
                        );
                      })}
                    <Step title={"Document Verification"} />
                    <Step
                      className={stepsVisible?.IsSelected ? "onboard" : ""}
                      title={
                        stepsVisible?.IsSelected ? (
                          <span
                            style={{
                              color: "green",
                            }}
                          >
                            Onboarded
                          </span>
                        ) : (
                          <span>Onboarding</span>
                        )
                      }
                    />
                  </Steps>
                </div>
              ) : (
                <div className="col-lg-10 p-0 my-lg-0 my-2">
                  <Steps size="small" labelPlacement="vertical" percent={60}>
                    <Step
                      title="L1 Round"
                      status={findInterviewByType("L1")}
                      subTitle={
                        stepsVisible.L1_Status === "Rejected" && (
                          <img
                            src={RejectImage}
                            style={{ width: 50, height: 50 }}
                            alt=""
                          />
                        )
                      }
                    />
                    <Step
                      title="L2 Round"
                      status={findInterviewByType("L2")}
                      subTitle={
                        stepsVisible.L2_Status === "Rejected" && (
                          <img
                            src={RejectImage}
                            style={{ width: 50, height: 50 }}
                            alt=""
                          />
                        )
                      }
                    />

                    <Step
                      title={`${interviews[2]
                        ? interviews[2]?.type === "clientRound"
                          ? "Final/Versant Round"
                          : interviews[2]?.type[0]?.toUpperCase() +
                          interviews[2]?.type?.slice(1) +
                          " Round"
                        : "Final/Versant Round"
                        }`}
                      status={findInterviewByType(
                        interviews[2]
                          ? interviews[2]?.type === "clientRound"
                            ? "final/versant"
                            : interviews[2]?.type
                          : "Final/Versant Round",
                      )}
                      subTitle={
                        stepsVisible.L3_Status === "Rejected" && (
                          <img
                            src={RejectImage}
                            style={{ width: 50, height: 50 }}
                            alt=""
                          />
                        )
                      }
                    />

                    <Step
                      title="Client Round"
                      status={findInterviewByType("clientRound")}
                      subTitle={
                        stepsVisible.L4_Status === "Rejected" && (
                          <img
                            src={RejectImage}
                            style={{ width: 50, height: 50 }}
                            alt=""
                          />
                        )
                      }
                    />

                    <Step
                      title="Document Verification"
                      status={
                        isDocSent
                          ? candidate.documentsVerifiedStatus === false
                            ? "process"
                            : "finish"
                          : "wait"
                      }
                    />

                    <Step
                      className={stepsVisible?.IsSelected ? "onboard" : ""}
                      status={stepsVisible?.IsSelected ? "process" : "wait"}
                      title={
                        stepsVisible?.IsSelected ? (
                          <span
                            style={{
                              color: "green",
                              fontWeight: "bold",
                            }}
                          >
                            Onboarded
                          </span>
                        ) : (
                          <span>Onboarding</span>
                        )
                      }
                    />
                  </Steps>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-lg-6 col-12 padding-l">
                {!candidate?.form && (
                  <Card
                    className="border mb-4 bg-white"
                    title={
                      <div id="attachment">
                        <span>Select Form</span>
                      </div>
                    }
                  >
                    <div className="p-0">
                      <Select
                        showSearch
                        // value={""}
                        className="filter-group-select w-100 "
                        placeholder="Application Type"
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                          return (
                            option?.children
                              ?.toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0 ||
                            option.value
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          );
                        }}
                        onChange={(value) => {
                          bindForm(value);
                        }}
                      >
                        {formNames
                          ?.sort((a, b) =>
                            a.name
                              ?.trim()
                              .toLowerCase()
                              .localeCompare(b.name?.trim().toLowerCase()),
                          )
                          ?.map((form) => {
                            if (
                              form.formType &&
                              form.formType === "Joining_Form"
                            ) {
                              return (
                                <Option key={form?._id} value={form?._id}>
                                  {form?.name?.trim()}
                                </Option>
                              );
                            }
                          })}
                      </Select>
                    </div>
                  </Card>
                )}

                <Card
                  className="border mb-4 bg-white"
                  title={
                    <div className="d-flex align-items-center">
                      <span>Call Discussion Status</span>
                    </div>
                  }
                  extra={
                    isAmeyoActive && !IS_NON_AGENT && !canViewCallDiscussion && !showManualDisposition && (
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={onClickAddManually}
                      >
                        Add manually
                      </button>
                    )
                  }
                >
                  <div className="mb-2 d-flex justify-content-between">
                    <span>
                      Call Status : {(() => {
                        const base = [
                          candidate?.callMasterId,
                          candidate?.callStatusMasterId,
                        ]
                          .filter(Boolean)
                          .join(" - ");

                        if (IS_NON_AGENT) {
                          if (base && base.trim() !== "") {
                            return base;
                          }
                          return "NA";
                        }

                        const statusList = (Array.isArray(candidate?.interviewCallStatus) && candidate?.interviewCallStatus?.length > 0)
                          ? candidate.interviewCallStatus
                          : ((Array.isArray(candidate?.interviewStatus) && candidate?.interviewStatus?.length > 0)
                            ? candidate.interviewStatus
                            : null);

                        if (statusList && statusList.length > 0) {
                          const latestObj = statusList[statusList.length - 1];
                          if (latestObj) {
                            if (typeof latestObj === "string" && latestObj.trim() !== "" && latestObj !== "NA") {
                              return latestObj;
                            }
                            if (typeof latestObj === "object") {
                              const userDisp = (typeof latestObj.userDisposition === "string" && latestObj.userDisposition.trim() !== "" && latestObj.userDisposition.trim() !== "NA") ? latestObj.userDisposition.trim() : null;
                              const sysDisp = (typeof latestObj.systemDisposition === "string" && latestObj.systemDisposition.trim() !== "" && latestObj.systemDisposition.trim() !== "NA") ? latestObj.systemDisposition.trim() : null;
                              const parts = [sysDisp, userDisp].filter(Boolean);
                              if (parts.length > 0) {
                                return Array.from(new Set(parts)).join(" - ");
                              }
                              const fallbackVal = latestObj.status || latestObj.callStatus;
                              if (fallbackVal && fallbackVal !== "NA") {
                                return typeof fallbackVal === "object" ? JSON.stringify(fallbackVal) : fallbackVal;
                              }
                            }
                          }
                        }

                        return "NA";
                      })()}
                    </span>
                    {!IS_NON_AGENT && isAmeyoActive && (
                      <span>
                        No of attempts : {candidate?.ameyoData?.reTry ?? candidate?.reTry ?? candidate?.retry ?? "NA"}
                      </span>
                    )}
                  </div>
                  <div className="row mb-3">
                    {!isAmeyoActive || IS_NON_AGENT || canViewCallDiscussion || showManualDisposition ? (
                      <>
                        <div className="customSelect col-md-6">
                          <select
                            id="FormType"
                            className="my-1 form-control "
                            onChange={changeStatus}
                            value={callStatus}
                          >
                            <option value="">---Select---</option>
                            {callMaster?.map((call) => {
                              return (
                                <option key={call._id} value={call._id}>
                                  {call.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        {callStatusMaster?.length !== 0 && callStatus && (
                          <div className="customSelect col-md-6">
                            <select
                              id="FormType1"
                              className="my-1 form-control"
                              onChange={changeStatusResponse}
                              value={callStatusRes}
                            >
                              <option value="">---Select---</option>
                              {callStatusMaster?.map((master) => {
                                return (
                                  <option key={master._id} value={master._id}>
                                    {" "}
                                    {master.callStatus}{" "}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        )}
                        {isManualCallbackDisposition && (
                          <div className="customSelect col-md-6 d-flex align-items-center">
                            <DatePicker
                              style={{ width: "100%", height: "37px" }}
                              showTime
                              value={reminderTime ? moment(reminderTime) : null}
                              onChange={onChange}
                              disabledDate={disabledDate}
                              disabledTime={disabledTime}
                              placeholder="Select Reminder Date & Time"
                            />
                          </div>
                        )}
                        <div className="col-md-6">
                          {canSaveCallDiscussion && (
                            <button
                              type="button"
                              className="btn btn-outline-secondary my-1 w-100"
                              onClick={saveStatus}
                            >
                              SAVE
                            </button>
                          )}
                        </div>
                      </>
                    ) : isCallbackDisposition ? (
                      <>
                        <div className="customSelect col-md-6 d-flex align-items-center">
                          <DatePicker
                            style={{ width: "100%", height: "37px" }}
                            showTime
                            value={reminderTime ? moment(reminderTime) : null}
                            onChange={onChange}
                            disabledDate={disabledDate}
                            disabledTime={disabledTime}
                            placeholder="Select Reminder Date & Time"
                          />
                        </div>
                        <div className="col-md-6">
                          {canSaveCallDiscussion && (
                            <button
                              type="button"
                              className="btn btn-outline-secondary my-1 w-100"
                              onClick={saveStatus}
                            >
                              SAVE
                            </button>
                          )}
                        </div>
                      </>
                    ) : null}
                  </div>
                  {isAmeyoActive && candidate?.trf?.candidateType !== "Non-Agent" && (
                    <div className="mt-2 text-muted" style={{ fontSize: "12px" }}>
                      <strong>Disclaimer:</strong> {showManualDisposition ? '"Based on the selected disposition, the lead will move to the respective tab."' : '"The call status will be displayed here once the call is completed."'}
                    </div>
                  )}
                </Card>
                <Card
                  className="border mb-4 bg-white"
                  title="Candidate Details"
                >
                  {/* <h5 className="font-weight-bold pb-3">Candidate Details</h5> */}
                  <div className=" p-0">
                    {candidate?.responses?.length !== 0 ? (
                      <table className="table bg-white respons-table">
                        <tbody>
                          <tr>
                            <th>
                              {" "}
                              {s3Files?.photo !== ""
                                ? "Uploaded Photo"
                                : "Upload Photo"}
                            </th>
                            {s3Files?.photo !== "" ? (
                              <td>
                                <div
                                  className="d-flex align-items-center"
                                  style={{ gap: "0.5rem" }}
                                >
                                  <Image
                                    width={60}
                                    height={60}
                                    src={s3Files?.photo}
                                  />
                                  <span className="d-flex">
                                    <CheckOutlined
                                      style={{
                                        borderRadius: "50%",
                                        padding: 2,
                                        marginRight: "5px",
                                      }}
                                      className={"__initial_accepted_icon"}
                                    />

                                    <span
                                      className="font-weight-bold"
                                      style={{
                                        color: "#00AC1A",
                                      }}
                                    >
                                      Uploaded
                                    </span>
                                  </span>
                                </div>
                              </td>
                            ) : (
                              <td className="d-flex gap-1 align-items-center">
                                <ShareAltOutlined />
                                {canSendNonAgentDocs && (
                                  <>
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        const url = `${process.env.REACT_APP_DOMAIN}/update-candidate/${candidate?.form?._id}/${candidate?._id}/long-form`;
                                        sendLink(url);
                                      }}
                                    >
                                      Share Upload Link
                                    </span>
                                    <button
                                      onClick={() => {
                                        navigator.clipboard
                                          .writeText(
                                            `${process.env.REACT_APP_DOMAIN}/update-candidate/${candidate?.form?._id}/${candidate?._id}/long-form`,
                                          )
                                          .then(() => {
                                            setCopyLink(true);
                                          });
                                      }}
                                      className="d-inline-flex bg-white outline-none"
                                    >
                                      {copyLink ? (
                                        <span className="text-success">
                                          <span className="bg-success text-white d-inline-flex p-1 rounded-circle">
                                            <CheckOutlined />
                                          </span>
                                        </span>
                                      ) : (
                                        <CopyOutlined />
                                      )}
                                    </button>
                                  </>
                                )}
                              </td>
                            )}
                          </tr>
                          {candidate.responses
                            .filter((response) => {
                              return response.element.fillableByCandidate;
                            })
                            .map((response, k) => {
                              let value = response.value;
                              if (response.element.type === "checkbox") {
                                value = Array.isArray(value) ? value.join(", ") : (value || "");
                              }
                              if (response?.element?.type === "multiSelect") {
                                value = Array.isArray(value) ? value.join(", ") : (value || "");
                              }
                              if (response?.element?.type === "file") {
                                // value = value ? value.split("\\").pop() : "";
                              }
                              if (response?.element?.type === "date") {
                                value = formatDateDDMMYYYY(new Date(value));
                              }
                              if (response.element.type === "texttable") {
                                value = (
                                  <table className="table table-striped">
                                    <thead>
                                      <tr>
                                        {response.element.properties.options.map(
                                          (option, k) => (
                                            <th key={k}>{option}</th>
                                          ),
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.values(
                                        JSON.parse(response.value),
                                      ).map((v, k) => (
                                        <tr key={k}>
                                          {Object.values(v).map(
                                            (value, key) => (
                                              <td key={key}>{value}</td>
                                            ),
                                          )}
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                );
                              }
                              if (
                                response.element.type !== "file" &&
                                response.element.type !== "capturephoto"
                              ) {
                                return (
                                  <tr key={k}>
                                    <th>{response.label}</th>
                                    <td>{value}</td>
                                  </tr>
                                );
                              }
                            })}
                        </tbody>
                      </table>
                    ) : (
                      <table className="table bg-white respons-table">
                        <tbody>
                          <tr>
                            <th>
                              {" "}
                              {s3Files?.photo !== ""
                                ? "Uploaded Photo"
                                : "Upload Photo"}
                            </th>
                            {s3Files?.photo !== "" ? (
                              <td>
                                <div
                                  className="d-flex align-items-center"
                                  style={{ gap: "0.5rem" }}
                                >
                                  <Image
                                    width={60}
                                    height={60}
                                    src={s3Files?.photo}
                                  />
                                  <span className="d-flex">
                                    <CheckOutlined
                                      style={{
                                        borderRadius: "50%",
                                        padding: 2,
                                        marginRight: "5px",
                                      }}
                                      className={"__initial_accepted_icon"}
                                    />

                                    <span
                                      className="font-weight-bold"
                                      style={{
                                        color: "#00AC1A",
                                      }}
                                    >
                                      Uploaded
                                    </span>
                                  </span>
                                </div>
                              </td>
                            ) : (
                              <td className="d-flex gap-1 align-items-center">
                                <ShareAltOutlined />
                                {canSendNonAgentDocs && (
                                  <>
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        const url = `${process.env.REACT_APP_DOMAIN}/update-candidate/${candidate?.form?._id}/${candidate?._id}/short-form`;
                                        sendLink(url);
                                      }}
                                    >
                                      Share Upload Link
                                    </span>
                                    <button
                                      onClick={() => {
                                        navigator.clipboard
                                          .writeText(
                                            `${process.env.REACT_APP_DOMAIN}/update-candidate/${candidate?.form?._id}/${candidate?._id}/short-form`,
                                          )
                                          .then(() => {
                                            setCopyLink(true);
                                          });
                                      }}
                                      className="d-inline-flex bg-white outline-none"
                                    >
                                      {copyLink ? (
                                        <span className="text-success">
                                          <span className="bg-success text-white d-inline-flex p-1 rounded-circle">
                                            <CheckOutlined />
                                          </span>
                                        </span>
                                      ) : (
                                        <CopyOutlined />
                                      )}
                                    </button>
                                  </>
                                )}
                              </td>
                            )}
                          </tr>
                          <tr>
                            <th>Name</th>
                            <td>{candidate.name}</td>
                          </tr>
                          <tr>
                            <th>Email</th>
                            <td>{candidate.email}</td>
                          </tr>
                          <tr>
                            <th>Phone Number</th>
                            <td>{candidate.mobileNo}</td>
                          </tr>
                          <tr>
                            <th>Source</th>
                            <td>{candidate.sourceType}</td>
                          </tr>
                          <tr>
                            <th>Preferred Location</th>
                            <td>{LOCATION || candidate.location}</td>
                          </tr>
                          <tr>
                            <th>Current Location</th>
                            <td>{CURRENT_LOCATION || candidate?.current_location || "-"}</td>
                          </tr>
                          {QUALIFICATION && (
                            <tr>
                              <th>Highest Qualification</th>
                              <td>{QUALIFICATION}</td>
                            </tr>
                          )}
                          {LANGUAGES && (
                            <tr>
                              <th>Languages Known</th>
                              <td>{Array.isArray(LANGUAGES) ? LANGUAGES.join(", ") : LANGUAGES}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {!candidate.IsSelected && candidate?.form && (
                      <>
                        {candidate.responses.length !== 0
                          ? canEditCandidate && (
                            <button
                              className={`btn btn-sm ${!candidate?.isEmpTempIdCreated
                                ? "btn-primary"
                                : "btn-secondary"
                                } btn-table-control mx-1`}
                              onClick={updateCandidate}
                              disabled={candidate?.isEmpTempIdCreated}
                            >
                              {/* simple edit form data */}
                              Edit
                            </button>
                          )
                          : canEditCandidate && (
                            <button
                              disabled={
                                (stepsVisible?.L3_Status === "Selected" &&
                                  stepsVisible?.trf?.trfType === "Sampark") ||
                                  (stepsVisible?.L4_Status === "Selected" &&
                                    stepsVisible?.trf?.trfType === "Sampark")
                                  ? true
                                  : false
                              }
                              className="btn btn-sm btn-primary btn-table-control mx-1"
                              onClick={editBulkCandidate}
                            >
                              Edit
                            </button>
                          )}
                      </>
                    )}

                    <CandidateFiles files={candidate.files} />
                  </div>
                </Card>
                {candidate?.voiceBotData && (
                  <VoiceBotDetails
                    loadCandidate={loadCandidate}
                    setLoad={setLoad}
                    candidate={candidate}
                    isAdmin={isAdmin}
                    canEditAdditionalInfo={canEditAdditionalInfo}
                  />
                )}
              </div>
              <div className="col-lg-6 col-12 padding-r">
                <Card className="border mb-4 bg-white" title="TRF Details">
                  {(candidate.trf === undefined ||
                    candidate.trf === null ||
                    trfEditStatus) &&
                    canEditTrf && (
                      <div>
                        <select
                          name="location"
                          id="location"
                          className="col form-control"
                          value={location ? location : locationData}
                          onChange={handleLocation}
                        >
                          <label value={locationData ? locationData : ""}>
                            {locationData ? locationData : "Select Location"}
                          </label>
                          {/* <option value={locationData ? locationData : ""}>{locationData ? locationData : "Select Location"}</option> */}
                          {locationData === "" && (
                            <option value="">Select Location</option>
                          )}
                          {preferredLocation?.map((obj) => {
                            return (
                              <option
                                //selected
                                key={obj?.locationName}
                                value={obj?.locationName}
                              >
                                {obj?.locationName}
                              </option>
                            );
                          })}
                        </select>

                        <br />

                        {(location !== "" || trfEditStatus) && (
                          <RSelect
                            value={trfCollection.map((ele) => {
                              if (ele._id === values) {
                                return {
                                  label:
                                    ele?.title +
                                    "-" +
                                    ele?.department +
                                    "-" +
                                    ele?.location +
                                    "-" +
                                    ele?.processName +
                                    "-" +
                                    moment(ele?.tat)
                                      .utc()
                                      .format("YYYY-MM-DD") +
                                    "-" +
                                    ele?.businessType?.toUpperCase() +
                                    "-" +
                                    `(${ele?.candidateType})` +
                                    (ele?.workModal ? "-" + ele.workModal : ""),
                                  value: ele._id,
                                };
                              } else if (values === "") {
                                setValues(trfData._id);
                                return {
                                  label:
                                    trfData?.title +
                                    "-" +
                                    trfData?.department +
                                    "-" +
                                    trfData?.location +
                                    "-" +
                                    ele?.processName +
                                    "-" +
                                    moment(trfData?.tat)
                                      .utc()
                                      .format("YYYY-MM-DD") +
                                    "-" +
                                    trfData?.businessType?.toUpperCase() +
                                    "-" +
                                    `(${trfData?.candidateType})` +
                                    (trfData?.workModal ? "-" + trfData.workModal : ""),
                                  value: trfData._id,
                                };
                              }
                            })}
                            options={trfCollection.map((trf) => {
                              return {
                                label:
                                  trf?.title +
                                  "-" +
                                  trf?.department +
                                  "-" +
                                  trf?.location +
                                  "-" +
                                  trf?.processName +
                                  "-" +
                                  moment(trf?.tat).utc().format("YYYY-MM-DD") +
                                  "-" +
                                  trf?.businessType?.toUpperCase() +
                                  "-" +
                                  `(${trf?.candidateType})` +
                                  (trf?.workModal ? "-" + trf.workModal : ""),
                                value: trf._id,
                              };
                            })}
                            onChange={(e) => {
                              setTrfErr("");
                              // checkVacancyCount(e.value);
                              // checkTinBasedProcess(e.value)
                              setValues(e.value);
                            }}
                          ></RSelect>
                        )}

                        {trfErr !== "" && (
                          <span style={{ color: "red" }}>{trfErr}</span>
                        )}
                        {canEditTrf && (
                          <div className="mt-2">
                            <button
                              className="btn-sm btn-primary"
                              onClick={async (e) => {
                                const trfData = trfCollection.find(
                                  (_trf) => _trf?._id === values,
                                );

                                const isAgent = ["agent", "gig"].includes(
                                  trfData?.candidateType?.toLowerCase(),
                                );
                                const isNonAgent =
                                  trfData?.candidateType === "Non-Agent";

                                const app =
                                  candidate?.form?._id ===
                                    process.env.REACT_APP_AGENT_FORM_ID
                                    ? "Agent"
                                    : "Non-Agent";

                                if (
                                  (isAgent &&
                                    candidate?.form?._id !==
                                    process.env.REACT_APP_AGENT_FORM_ID) ||
                                  (isNonAgent &&
                                    candidate?.form?._id !==
                                    process.env.REACT_APP_NON_AGENT_FORM_ID)
                                ) {
                                  await swal({
                                    title: "Error",
                                    // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
                                    icon: "error",
                                    content: {
                                      element: "div",
                                      attributes: {
                                        innerHTML: `<p style="text-align:center">You cannot bind ${app} application to an ${trfData?.candidateType} TRF.</p>`,
                                      },
                                    },
                                    buttons: {
                                      confirm: true,
                                    },
                                  });
                                  return;
                                }

                                if (
                                  trfData?.isTRFApproved === null &&
                                  isDocEmpty
                                ) {
                                  await swal({
                                    title: "Error",
                                    // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
                                    icon: "error",
                                    content: {
                                      element: "div",
                                      attributes: {
                                        innerHTML: `<p style="text-align:center">The In-progress TRF cannot be assigned until the documents are pulled back.</p>`,
                                      },
                                    },
                                    buttons: {
                                      confirm: true,
                                    },
                                  });
                                  return;
                                }

                                if (trfData?.candidateType === "Non-Agent") {
                                  if (trfData?.interviewNames?.length === 0) {
                                    await swal({
                                      title: "Error",
                                      // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
                                      icon: "error",
                                      content: {
                                        element: "div",
                                        attributes: {
                                          innerHTML: `<p style="text-align:center">Interviews not bind with this TRF.</p>`,
                                        },
                                      },
                                      buttons: {
                                        confirm: true,
                                      },
                                    });
                                    return;
                                  }
                                }
                                if (!values || values === "") {
                                  setTrfErr("Please select Location & TRF");
                                  success("trfErr");
                                  return;
                                }
                                saveTrf(e);
                              }}
                              size={"large"}
                              disabled={!canEditTrf}
                            >
                              Submit
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  {candidate.trf !== undefined &&
                    candidate.trf !== null &&
                    !trfEditStatus ? (
                    <div>
                      <p className="d-flex gap-1 align-items-center">
                        <span className="d-flex align-items-center">
                          <h6 className="mb-0" style={{ fontWeight: "600" }}>
                            {" "}
                            Business Type : &nbsp;
                          </h6>
                          <span>{candidate?.trf?.businessType}</span>
                        </span>
                        <span className="d-flex align-items-center">
                          <h6 className="mb-0" style={{ fontWeight: "600" }}>
                            {" "}
                            TRF Type : &nbsp;
                          </h6>
                          <span>{candidate?.trf?.candidateType}</span>
                        </span>
                      </p>
                      <p>
                        <b>TRF:-</b>
                        {candidate?.trf?.title}-{candidate?.trf?.department}-
                        {candidate?.trf?.location}-{candidate?.trf?.processName}
                        -
                        {candidate?.trf?.tat &&
                          moment(candidate?.trf?.tat)
                            .utc()
                            .format("YYYY-MM-DD")}
                        {candidate?.trf?.workModal ? `-${candidate.trf.workModal}` : ""}{" "}
                        -{" "}
                        <b>
                          <TRFIndicator candidate={candidate} />
                        </b>
                      </p>
                      {candidate?.form?.name !== "skill development" && canEditTrf && (
                        <>
                          <button
                            disabled={trfStatus()}
                            className={
                              trfStatus()
                                ? "btn-sm btn-secondary"
                                : "btn-sm btn-primary"
                            }
                            onClick={trfEdit}
                          >
                            Edit Trf
                          </button>
                        </>
                      )}
                    </div>
                  ) : (
                    <>
                      {!canEditTrf && !candidate.trf && (
                        <div style={{ maxWidth: 500, padding: 5 }}>
                          <h5 style={{ fontSize: "18px", margin: 0 }}>
                            TRF not assigned yet.
                          </h5>
                        </div>
                      )}
                    </>
                  )}
                </Card>
                <Card
                  className="border mb-4 bg-white"
                  title={
                    <div>
                      <div className="flex items-center">
                        <h1>Interviews</h1>
                        {candidate?.trf?.candidateType === "Agent" && interviews?.some(item => item?.type === "L1") && (
                          <a
                            href="#"
                            style={{ textDecoration: "underline", fontSize: "14px", marginLeft: "auto", color: "#19466b" }}
                            onClick={(e) => { e.preventDefault(); setExtraScore((prev) => !prev); }}
                          >
                            Additional Score
                          </a>
                        )}
                      </div>
                      {extraScore && (
                        <div style={{ marginTop: 12 }}>
                          <ExtraScore
                            setLoad={setLoad}
                            candidate={candidate}
                            setExtraScore={setExtraScore}
                            loadCandidate={loadCandidate}
                            isDocumentSent={candidate?.isDocumentSent || formData?.some(ele => ele.sentStatus === true)}
                          />
                        </div>
                      )}
                    </div>
                  }
                >
                  {IS_NON_AGENT ? (
                    <>
                      {showInterviewsComponent && (
                        <div
                          style={{ maxWidth: 500, margin: "auto", padding: 5 }}
                        >
                          {dynamicInterviews?.map((_interview, index) => {
                            const interviewFound = interviews?.find(
                              (ele) =>
                                _interview?._id ===
                                ele?.designationInterviewsNamesMappingId,
                            );

                            // const interviewFound =
                            //   Object.keys(_interview?.interviewDetailsBind)
                            //     .length !== 0
                            //     ? _interview?.interviewDetailsBind
                            //     : undefined;

                            const interviewer =
                              interviewFound?.interviewer || "N/A";
                            const start = interviewFound?.start || "TBD";
                            const end = interviewFound?.end || "TBD";
                            const finished = interviewFound?.finished;
                            const status = interviewFound?.status || "N/A";
                            const rating = interviewFound?.rating;
                            const remarks = interviewFound?.remarks || "N/A";

                            return (
                              <Card
                                key={_interview?._id}
                                style={{
                                  marginBottom: 16,
                                  borderRadius: 8,
                                  background: "#F8F9FC",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Title
                                    level={5}
                                    style={{
                                      margin: 0,
                                      color: !interviewFound ? "#999999" : "",
                                    }}
                                  >
                                    Round {_interview?.interviewNo}:{" "}
                                    {
                                      _interview?.interviewDetails
                                        ?.interviewNames
                                    }
                                  </Title>
                                  {!interviewFound ? (
                                    <div className="px-4 py-2 pending-tab rounded-bottom position-absolute tab-position">
                                      Pending
                                    </div>
                                  ) : finished ? (
                                    <div className="px-4 py-2 score-tab rounded-bottom position-absolute tab-position">
                                      Score: {rating[0]?.rating}/5
                                    </div>
                                  ) : (
                                    <div className="px-4 py-2 upcoming-tab rounded-bottom position-absolute tab-position">
                                      Upcoming
                                    </div>
                                  )}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: 20,
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <Text
                                      style={{
                                        color: !interviewFound ? "#999999" : "",
                                      }}
                                    >
                                      Interviewer:{" "}
                                      <a
                                        style={{
                                          color: !interviewFound
                                            ? "#999999"
                                            : "",
                                        }}
                                        className="text-dark "
                                        href="#"
                                      >
                                        {interviewer}
                                      </a>
                                    </Text>
                                    <br />
                                    <Text
                                      style={{
                                        color: !interviewFound ? "#999999" : "",
                                      }}
                                    >
                                      Start Date: {start}
                                    </Text>
                                    <br />
                                    <Text
                                      style={{
                                        color: !interviewFound ? "#999999" : "",
                                      }}
                                    >
                                      End Date: {end}
                                    </Text>
                                    <br />
                                    <Text
                                      style={{
                                        color: !interviewFound ? "#999999" : "",
                                      }}
                                    >
                                      Status: {status}
                                    </Text>
                                    <br />
                                    <Text
                                      style={{
                                        color: !interviewFound ? "#999999" : "",
                                      }}
                                    >
                                      Remarks: {remarks}
                                    </Text>
                                  </div>
                                  {interviewFound &&
                                    !interviewFound?.finished &&
                                    !interviewFound?.rejectionReason &&
                                    canTakeInterview && (
                                      <button
                                        onClick={(e) => {
                                          history.push(
                                            `/interview/process/${candidate?.trf?.designationId}/${interviewFound?._id}/${_interview?.interviewNamesId}/${candidate?._id}?tab=${TAB}`,
                                          );
                                        }}
                                        className="btn-primary btn"
                                      >
                                        START
                                      </button>
                                    )}
                                  {((interviewFound &&
                                    interviewFound?.finished) ||
                                    interviewFound?.rejectionReason) && (
                                      <button
                                        onClick={(e) => {
                                          history.push(
                                            `/interview/process/${candidate?.trf?.designationId}/${interviewFound?._id}/${_interview?.interviewNamesId}/${candidate?._id}?tab=${TAB}`,
                                          );
                                        }}
                                        className="btn-primary btn"
                                      >
                                        View
                                      </button>
                                    )}
                                  {!interviewFound &&
                                    interviews?.length >= 0 &&
                                    !interviews?.some(
                                      (item) => item.finished === false,
                                    ) &&
                                    !candidate?.isDocumentSent && (
                                      <>
                                        {canArrangeInterview && (
                                          <button
                                            onClick={(e) => {
                                              const voiceCount =
                                                tinData?.voiceCount || 0;
                                              const writtenCount =
                                                tinData?.writtenCount || 0;
                                              const totalTin =
                                                voiceCount + writtenCount;
                                              if (
                                                !tinOptions &&
                                                _interview?.interviewDetails
                                                  ?.interviewNames ===
                                                "Versant Round"
                                              ) {
                                                swal({
                                                  title: "Error",
                                                  // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
                                                  icon: "error",
                                                  content: {
                                                    element: "div",
                                                    attributes: {
                                                      innerHTML: `<p style="text-align:center">Process is not mapped under the Versant Configuration.</p>`,
                                                    },
                                                  },
                                                  buttons: {
                                                    confirm: true,
                                                  },
                                                });
                                                return;
                                              } else {
                                                if (
                                                  totalTin <= 0 &&
                                                  _interview?.interviewDetails
                                                    ?.interviewNames ===
                                                  "Versant Round"
                                                ) {
                                                  swal({
                                                    title: "Error",
                                                    // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
                                                    icon: "error",
                                                    content: {
                                                      element: "div",
                                                      attributes: {
                                                        innerHTML: `<p style="text-align:center">TIN not available.</p>`,
                                                      },
                                                    },
                                                    buttons: {
                                                      confirm: true,
                                                    },
                                                  });
                                                  return;
                                                }
                                              }

                                              setInterviewId(_interview);
                                              setArrangeInterview(true);
                                            }}
                                            className={`btn-primary btn-lg`}
                                          //disabled={!canArrangeInterview}
                                          >
                                            Arrange
                                          </button>
                                        )}
                                      </>
                                    )}
                                </div>
                              </Card>
                            );
                          })}
                          {dynamicInterviews?.length !== interviews.length && (
                            <div className="d-flex justify-content-end-['">
                              <div
                                style={{ gap: "0.5rem" }}
                                className="d-flex align-items-center"
                              >
                                <input
                                  id="doc_process"
                                  type="checkbox"
                                  name="doc"
                                  disabled={
                                    !DISABLE_DOCUMENT_PROCESS ||
                                    isDocEmpty ||
                                    !canProceedWithDocument
                                  }
                                  checked={
                                    isDocReadyForSent ||
                                    candidate?.isDocumentSent ||
                                    isDocEmpty
                                  }
                                  defaultChecked={isDocReadyForSent}
                                  onChange={proceedWithDocument}
                                  style={{ transform: "scale(1.3)" }}
                                />
                                <label htmlFor="doc_process" className="mb-0">
                                  Proceed with Document
                                </label>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {!showInterviewsComponent && (
                        <div style={{ maxWidth: 500, padding: 5, marginTop: 10 }}>
                          <h5 style={{ fontSize: "18px", margin: 0 }}>
                            Please arrange call first.
                          </h5>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {showAgentInterviews && (
                        <>
                          {!isNonAgent_candidate && (
                            <div className="p-0">
                              <LanguageConfidence candidate={candidate} />
                            </div>
                          )}
                          <CandidateSingleInterview
                            id={candidate._id}
                            candidate={candidate}
                            s3Files={s3Files?.photo || ""}
                            processes={processes}
                            users={users}
                            interviews={interviews}
                            getInterviews={getInterviews}
                            setInterviewStatus={setInterviewStatus}
                            interviewStatus={interviewStatus}
                            updateTrf={updateTrf}
                            isCallDiscussionPending={isCallDiscussionPending}
                            canArrangeInterview={canArrangeInterview}
                            canTakeInterview={canTakeInterview}
                            canMakeInterviewEditable={canMakeInterviewEditable}
                            canEditTrf={canEditTrf}
                            loadCandidate={loadCandidate}
                            refreshInterviewDetails={refreshInterviewDetails}
                            getDoc={getDoc}
                            tinData={tinData}
                            tinOptions={tinOptions}
                            getProcessBasedVersantConf={
                              getProcessBasedVersantConf
                            }
                          />
                        </>
                      )}
                      {!showAgentInterviews && (
                        <div style={{ maxWidth: 500, padding: 5, marginTop: 10 }}>
                          <h5 style={{ fontSize: "18px", margin: 0 }}>
                            Please arrange call first.
                          </h5>
                        </div>
                      )}
                    </>
                  )}


                </Card>
                {isDocSent ? (
                  <>
                    {candidate?.form?.formType !== "Skill_Form" && (
                      <Card
                        className="border mb-4 bg-white"
                        title="Document Forms called"
                      >
                        <CandidateForms
                          formList={formList}
                          formData={formData}
                          getDoc={getDoc}
                          candidate={candidate}
                          canSendNonAgentDocs={canSendNonAgentDocs}
                        />
                      </Card>
                    )}
                  </>
                ) : null}
                {/* } */}
              </div>
            </div>
            <div className="row">
              <div className="col-12 p-0">
                {!logStatus && (
                  <Card className="border mb-4" title="">
                    <div
                      className="d-flex align-items-center"
                      style={{ justifyContent: "space-between" }}
                    >
                      <h5
                        className="mb-0 font-weight-bold"
                        style={{ fontSize: "1.1rem" }}
                      >
                        History
                      </h5>
                      {canViewHistory && (
                        <button
                          className={"btn-sm btn-primary"}
                          onClick={saveInterviewLog}
                        >
                          View
                        </button>
                      )}
                    </div>
                  </Card>
                )}
                {logStatus && (
                  <Card className="border mb-4 bg-white" title="History">
                    {/* <h5 className="font-weight-bold">History</h5> */}
                    <div className="timeline">
                      <Timeline mode="right">
                        {/* <Timeline.Item label={status1 ? status1 : "New"}>
                        <p>Application Status</p>
                      </Timeline.Item> */}

                        {/* dynamic log tree of interview */}
                        {logStatus &&
                          logStatus.map((log) => {
                            return (
                              <Timeline.Item
                                label={
                                  <>
                                    <p>{log?.status ? log.status.replace(/,\s*undefined/gi, '').replace(/undefined/gi, '').trim() : ''}</p>
                                    <p
                                      onClick={() => {
                                        showModalFeedback(
                                          log.interviewId,
                                          log.interviewerId,
                                        );
                                      }}
                                      className="ml-1 d-inline"
                                    >
                                      <a href="#/">View feedback</a>
                                    </p>
                                  </>
                                }
                                color="green"
                              >
                                <p>Event: {log?.interviewId?.type}</p>
                                <p>
                                  Round {log?.interviewId?.type}{" "}
                                  {log?.logDate}{" "}
                                </p>
                                <p>
                                  Interviewer Name:-{" "}
                                  {log?.interviewerId?.name}{" "}
                                </p>
                                <p>
                                  Interviewer Owner:-{" "}
                                  {log?.interviewerOwnerId?.name}{" "}
                                </p>
                              </Timeline.Item>
                            );
                          })}
                      </Timeline>
                    </div>
                  </Card>
                )}
              </div>
            </div>
          </div>
          {/* feed back popup of 1st round interview */}
          <Modal
            className="request-modal"
            title={<h5 className="font-weight-bold mb-0">Feedback</h5>}
            visible={isModalVisibleFeedback}
            footer={false}
            onCancel={handleCancelFeedback}
          >
            <Badge.Ribbon text="Interview" color="#f27f21">
              <h4 className="hr-ratings-title m-0">
                {" "}
                Event: {feedbackRes?.type ? feedbackRes?.type : "Not Scheduled"}
              </h4>
            </Badge.Ribbon>
            <table className="table table-candidate">
              <tbody>
                <tr>
                  {/* <td>
                  <strong>Message</strong>
                </td> */}
                  <td>{feedbackRes?.description}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Interviewer</strong>
                  </td>
                  <td>{feedbackRes1?.name}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Start Time</strong>
                  </td>
                  <td>{feedbackDataL1?.start}</td>
                </tr>
                <tr>
                  <td>
                    <strong>End Time</strong>
                  </td>
                  <td>{feedbackDataL1?.end}</td>
                </tr>
              </tbody>
            </table>

            <div className="interview-ratings">
              <h4 className="hr-ratings-title">Ratings and Reviews</h4>
              {feedbackRes?.rating?.map((ele) => {
                return (
                  <div>
                    <div className="hr-rating row p-2 px-3">
                      {ele?.name}: {ele?.rating}
                    </div>
                    <div>{ele?.review}</div>
                  </div>
                );
              })}
              <h4 className="hr-ratings-title">Remarks</h4>
              <p>{feedbackDataL1?.remarks}</p>
            </div>
          </Modal>
        </div>
        <Else>
          <Loading />
        </Else>
      </If>
      <Modal
        open={arrangeInterview}
        onCancel={() => setArrangeInterview(!arrangeInterview)}
        title={null}
        width={650}
        footer={null}
        closable={true}
        className="p-0 custom_modal__"
      >
        <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white">
          <h5 className="modal-title text-white">Arrange Interview</h5>
        </div>
        <div className="modal-body">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => onSubmitInterview(values)}
          >
            {(formikProps) => (
              <Form>
                <div className="mt-2">
                  <label htmlFor="interviewer">Interviewer</label>
                  <Field className="form-control" name="interviewer">
                    {({ field, form, meta }) => {
                      const options = users.map((user) => {
                        return {
                          label: `${user.name} (${user.role})`,
                          value: user._id,
                        };
                      });
                      return (
                        <>
                          <SelectReact
                            style={{ width: "100%" }}
                            name={field.name}
                            placeholder="Select Interviewer"
                            value={
                              options
                                ? options.find(
                                  (option) => option.value === field.value,
                                )
                                : null
                            }
                            onChange={(option) => {
                              form.setFieldValue(field.name, option.value);
                            }}
                            onBlur={field.onBlur}
                            options={options}
                          />
                          {meta.touched && meta.error ? (
                            <div className="alert alert-danger my-1">
                              {meta.error}
                            </div>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                </div>

                <div className="mt-2">
                  <label htmlFor="description">Message</label>
                  <Field
                    type="text"
                    className="form-control"
                    name="description"
                  />
                  <ErrorMessage
                    render={(msg) => (
                      <div className="alert alert-danger my-1">{msg}</div>
                    )}
                    name="description"
                  />
                </div>

                {formikProps.values.type === "video" ? (
                  <div className="form-group">
                    <label htmlFor="link">Link</label>
                    <Field type="text" className="form-control" name="link" />
                    <ErrorMessage
                      render={(msg) => (
                        <div className="alert alert-danger my-1">{msg}</div>
                      )}
                      name="link"
                    />
                  </div>
                ) : null}

                <div className="mt-2">
                  <label htmlFor="start">Start Time </label>
                  <Field className="form-control" name="start">
                    {({ field, form, meta }) => {
                      return (
                        <div>
                          <DatePickerField
                            type="text"
                            className="form-control"
                            name={field.name}
                            showTimeSelect
                            dateFormat="Pp"
                            popperPlacement="top-end"
                            minDate={new Date()}
                            minTime={new Date()}
                            maxTime={new Date(new Date().setHours(23, 59, 59))}
                          />
                          {meta.touched && meta.error ? (
                            <div className="alert alert-danger my-1">
                              {meta.error}
                            </div>
                          ) : null}
                        </div>
                      );
                    }}
                  </Field>
                </div>
                <div className="mt-2">
                  <label htmlFor="end">End Time</label>
                  <Field className="form-control" name="end">
                    {({ field, form, meta }) => {
                      return (
                        <div>
                          <DatePickerField
                            type="text"
                            className="form-control"
                            name={field.name}
                            showTimeSelect
                            dateFormat="Pp"
                            popperPlacement="top-end"
                            minTime={new Date()}
                            maxTime={new Date(new Date().setHours(23, 59, 59))}
                            minDate={formikProps.values.start || new Date()}
                          />
                          {meta.touched && meta.error ? (
                            <div className="alert alert-danger my-1">
                              {meta.error}
                            </div>
                          ) : null}
                        </div>
                      );
                    }}
                  </Field>
                </div>
                <div className="mt-3">
                  <button
                    className="btn btn-primary"
                    type="submit"
                  // onClick={(e) => onSubmitInterview(formikProps.values)}
                  >
                    Arrange
                  </button>
                  <ButtonHint>
                    This will move candidate to the next board in the Screening
                    Board.
                  </ButtonHint>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </div>
  );
}

export default CandidateSingleView;
